import moment from "moment";
export const isServerEnv=true;
//export const rooturl="http://testapi.lagosjudiciary.gov.ng";
export const rooturl=isServerEnv?"http://testapi.lagosjudiciary.gov.ng": "http://localhost:5105";

export const baseurl=isServerEnv?"http://testnew.lagosjudiciary.gov.ng" : 'http://localhost:3000'; //testnew.lagosjudiciary.gov.ng/

export const primarySite="http://jisstaging.lagosjudiciary.gov.ng";
export const primary_doc_file=`${primarySite}/CaseDocuments`;


export const apiUrl=`${rooturl}/api`;

export const docUrl=`${rooturl}/resources/`;
export const lastSpecified="52500.00"; //casetype_component 736

export const CFO_Placeholders = new Set([12,24,26,27,65]); 
export const paystack_public="pk_test_657c8b8312c24ace7419a954beac2b8f4c43e65f";

export const CategoryList=[
  {id:1,title:'GENERAL CIVIL'},
{id:2,title:"LANDS"},
{id:6,title:"FAMILY AND PROBATE (DIVORCE, PURE PROBATE AND CUSTODY)"},
{id:14,title:"BAIL APPLICATION"},{id:7,title:"FUNDAMENTAL HUMAN RIGHT"},{id:15,title:"GRANTING LEAVE TO FILE DIVORCE"},{id:16, title:"JUDICIAL REVIEW"},
{id:3,title:"CRIMINAL"},{id:3,title:"CRIMINAL"},{id:4,title:"COMMERCIAL"},{id:9,title:"MORTGAGES AND REVENUE"}];
export const formatDateTime=(inputDateTime)=> {
    const options = {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    };
  
    const formattedDateTime = new Intl.DateTimeFormat('en-US', options).format(new Date(inputDateTime));
    return formattedDateTime;
  }
  export const formatDate=(inputDateTime)=> {
    const options = {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    
      hour12: true,
    };
  
    const formattedDateTime = new Intl.DateTimeFormat('en-US', options).format(new Date(inputDateTime));
    return formattedDateTime;
  }
  export const formatTime=(inputDateTime)=> {
    const options = {
     
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    };
  
    const formattedDateTime = new Intl.DateTimeFormat('en-US', options).format(new Date(inputDateTime));
    return formattedDateTime;
  }

  export const formatCurrency=(num)=>{
   // return parseFloat(num).toFixed(2);
   return formatter.format(num);
  }
  export const dateOnly=(value) =>{
    let dstring=  moment(value).format("YYYY-MM-DD");
    return dstring;
    //let d=new Date(dstring);
    //return d;
   }

   export function seo(data = {}) {
    data.title = data.title || 'Lagos Judiciary';
    data.metaDescription = data.metaDescription || 'Lagos Judiciary';
  
    document.title = data.title;
    document.querySelector('meta[name="description"]').setAttribute('content', data.metaDescription);
  }
  export const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    if(file){
      reader.readAsDataURL(file);
    }
   // reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
});
export const getCookie=(key) => {
  var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
}
export const AbsoluteFiletoRelative=(absolutepath)=>{
   //first split from last appearance of resources
   if(absolutepath==null)
   return '';
  
  var tn= absolutepath.split("Resources");
  var relative= apiUrl. slice(0, -3) +"Resources"+tn[1].replace(/\\/g, "/");
  return relative;
  
}
export const ReduceFilename=(filename)=>{
  if(filename.length>25){
   var aa= filename.split('.');
   if(aa.length==2){
     //exact senerio
    var nn= aa[0].substring(0,20)+"."+aa[1];
    return nn;
   }else{
     return aa[0]+"."+aa[aa.length-1];
   }
  }else{
  return filename;
  }
}

export const ReduceString=(value, max)=>{
  if(value.length>max){
     var s=value.substring(0,max)
    return s+'...';
  }else{
  return value;
  }
}
export const NoteExcept=(title)=>{
 return  title?.startsWith('NOTE');
}
const formatter = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: 'NGN',

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export const RewriteLocalUrl=(localurl)=>{
  let res =localurl.indexOf("Resources");
  let s =localurl.substring((res), localurl.length);
  return ( `${rooturl}/`+s);
}

export const CalUnSpecified =(bignumber)=>{
  var fixincamt="5000000";
  var incrementval = "2500";
  var difffromstart = "100000000";
  var diff = bignumber - difffromstart;
  var res = 0;
  var finalamt = 0;
  res = diff / fixincamt;
  //res = Math.floor(res);
  if (res > 0) {
      if (res <= 1) {
          finalamt = 1 * parseInt(incrementval);
      }
      else {
          finalamt = Math.ceil(res) * parseInt(incrementval);
      }
  }
  else {
      finalamt = 0;
  }

  var feeamount= lastSpecified //element 736 last value
 var calunspefamount = parseInt(feeamount) + parseInt(finalamt);
  return calunspefamount;
}

export const isNumber=(value)=> {
//console.log(`${typeof value} and the isNAN ${!Number.isNaN(value)}`)
  return  !Number.isNaN(value);

}
export const Distinct=(arr)=>{
  return Array.from( new Set( arr ) ) ;
}

export const ReplaceAll=(str,str1, str2,)=>
{
 //return str.replace(/replaceWhat/g,replaceTo);
const ignore=true;
  return str.replace(new RegExp(str1.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "\\$&"), (ignore ? "gi" : "g")), (typeof(str2) == "string") ? str2.replace(/\$/g, "$$$$") : str2);

}
export const CleanQuillHtml=(html)=>{
//replace all class="ql-align-center" to style="text-align:center"
// class="ql-align-right" style="text-align:right"
}
/* export const DocPermissionList =new Set([
  182,183,184,685, 189,196,702,707,196,693,703,
  708,712,713,714,189, 244,261,570,441,312,
   22,25,38,64 //680 //remove 680 on live
])  */
export const DocPermissionList =new Set([
  183,703,707,196,200,189,243,278,693,257,576,447,318,261,576,447,318,583,454,325,
  587,458,329, 15,16,22,25,35,38,39
]) 

export const DocPermissionList_ADR =new Set([
  42,46,55,58,88,89,101,105,119,127,147,149,154,157,158,179
]) 
export const getAlphaByNum=(n)=>{
  return String.fromCharCode(96 + n); //a is 96
}
export const getQueryString=(variable)=>
{
        var query = window.location.search.substring(1);
        console.log(query)//"app=article&act=news_content&aid=160990"
        var vars = query.split("&");
        console.log(vars) //[ 'app=article', 'act=news_content', 'aid=160990' ]
        for (var i=0;i<vars.length;i++) {
                    var pair = vars[i].split("=");
                    console.log(pair)//[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ] 
        if(pair[0] == variable){return pair[1];}
         }
         return(false);
}
export const getQuery=()=>
{
        var query = window.location.search.substring(1);
        console.log(query)//"app=article&act=news_content&aid=160990"
      
         return(query);
}
export const Checkfiles=(fileName)=>
        {
        //var fup = document.getElementById('filename');
        //var fileName = fup.value;
        var ext = fileName.substring(fileName.lastIndexOf('.') + 1);
        if(ext == "pdf" )
        {
        return true;
        } 
        else
        {
       
        return false;
        }
        }
      export const b64encode = (txt)=> { 
          return btoa(unescape(encodeURIComponent(txt))); 
      };
      export const b64decode = (txt) =>{ 
          return decodeURIComponent(escape(atob(txt))); 
      };

      export const  ConvertText=(str)=>{
       // return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
       return str.replace(/[^\x00-\x7F]/g, "");
      }

      export const QrCodelink=(str)=>{
        return `https://quickchart.io/qr?text=${str}&size=100`;
      }

      export const TitleCase=(str)=>{
        return str[0].toUpperCase() + str.slice(1).toLowerCase();
      }
      export const serverErr="Could not connect to the service at the moment. Please try again.";
export const IsNull=(v)=>{
  if(v==undefined || v==null)
    return true;
  else
  return false;
}
  